/**
 * Manually-entered audience demographic breakdowns for deliverables (Gender,
 * Age, Location) — for creators who haven't connected an account. Mirrors
 * the `demographics_*` metric_type naming Statistic::DEMOGRAPHIC_METRIC_TYPES
 * uses server-side (app/models/statistic.rb) so labels/placeholders stay in
 * one place instead of duplicated across editor + display components.
 */
export const DEMOGRAPHIC_GROUPS = [
  {
    metricType: "demographics_gender",
    label: "Gender",
    placeholder: "Search or type a value",
    // Unlike Age/Location, gender values don't really vary — offering
    // suggestions keeps "Female"/"female"/"Women" from all appearing as
    // separate, inconsistently-colored pie slices across deliverables.
    // Still free-text (allowCustom) for platforms that report other buckets.
    suggestions: ["Female", "Male", "Non-binary", "Other"],
  },
  {
    metricType: "demographics_age",
    label: "Age",
    placeholder: "e.g. 25-34",
  },
  {
    metricType: "demographics_geo_country",
    label: "Location",
    placeholder: "e.g. United States",
  },
];

export const DEMOGRAPHIC_METRIC_TYPES = DEMOGRAPHIC_GROUPS.map(
  (group) => group.metricType
);

const COUNTRY_FLAGS = {
  "united states": "🇺🇸",
  usa: "🇺🇸",
  us: "🇺🇸",
  "united kingdom": "🇬🇧",
  uk: "🇬🇧",
  canada: "🇨🇦",
  australia: "🇦🇺",
  germany: "🇩🇪",
  france: "🇫🇷",
  spain: "🇪🇸",
  italy: "🇮🇹",
  mexico: "🇲🇽",
  brazil: "🇧🇷",
  india: "🇮🇳",
  japan: "🇯🇵",
  "south korea": "🇰🇷",
  china: "🇨🇳",
  netherlands: "🇳🇱",
  sweden: "🇸🇪",
  norway: "🇳🇴",
  denmark: "🇩🇰",
  ireland: "🇮🇪",
  "new zealand": "🇳🇿",
  "south africa": "🇿🇦",
  philippines: "🇵🇭",
  indonesia: "🇮🇩",
  singapore: "🇸🇬",
  poland: "🇵🇱",
  portugal: "🇵🇹",
  switzerland: "🇨🇭",
  belgium: "🇧🇪",
  austria: "🇦🇹",
  argentina: "🇦🇷",
  colombia: "🇨🇴",
  chile: "🇨🇱",
  turkey: "🇹🇷",
  "united arab emirates": "🇦🇪",
  uae: "🇦🇪",
  thailand: "🇹🇭",
  vietnam: "🇻🇳",
  malaysia: "🇲🇾",
  israel: "🇮🇱",
  egypt: "🇪🇬",
  nigeria: "🇳🇬",
  kenya: "🇰🇪",
  others: null,
};

// Best-effort flag lookup for a free-typed country/region name. Returns null
// (no icon) for anything unmapped rather than guessing.
export function flagForCountry(name) {
  if (!name) return null;
  return COUNTRY_FLAGS[name.trim().toLowerCase()] || null;
}
